$(document).ready(function () {
    // === スライダー設定 ===
    const $slider = $('.modmv .sliderWrapper__slider');
    $slider.slick({
        arrows: false,
        dots: false,
        infinite: true, // trueで統一
        autoplay: true,
        autoplaySpeed: 2000,
    });
    $('.modmv .sliderWrapper__customDots .dot').on('click', function () {
        var index = $(this).data('index');
        $slider.slick('slickGoTo', index);
    });
    $slider.on('afterChange', function (event, slick, currentSlide) {
        $('.modmv .sliderWrapper__customDots .dot').removeClass('active');
        $('.modmv .sliderWrapper__customDots .dot[data-index="' + currentSlide + '"]').addClass('active');
    });
    $('.modmv .sliderWrapper__customDots .dot[data-index="0"]').addClass('active');

    // === スライダー設定2 ===
    const $slider_howto = $('.howto-slide .sliderWrapper__slider');
    $slider_howto.slick({
        arrows: false,
        dots: false,
        infinite: true, // trueで統一
        autoplay: true,
        autoplaySpeed: 3000,
    });
    $('.howto-slide .sliderWrapper__customDots .dot').on('click', function () {
        var index = $(this).data('index');
        $slider_howto.slick('slickGoTo', index);
    });
    $slider_howto.on('afterChange', function (event, slick, currentSlide) {
        $('.howto-slide .sliderWrapper__customDots .dot').removeClass('active');
        $('.howto-slide .sliderWrapper__customDots .dot[data-index="' + currentSlide + '"]').addClass('active');
    });
    $('.howto-slide .sliderWrapper__customDots .dot[data-index="0"]').addClass('active');

    // === Intersection ObserverによるCTA制御 ===
    const target = document.getElementById('main-cta-button');
    const floating = document.getElementById('floating-cta');

    if (target && floating) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        floating.classList.remove('show');
                    } else {
                        floating.classList.add('show');
                    }
                });
            },
            { root: null, threshold: 0 }
        );
        observer.observe(target);
    }

    // === スムーズスクロール（data-offset対応で一本化） ===
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);
            const container = document.querySelector('.l-container__inner');
            if (targetElement && container && container.contains(targetElement)) {
                const offset = parseInt(this.getAttribute('data-offset') || 0, 10);
                container.scrollTo({
                    top: targetElement.offsetTop + offset,
                    behavior: 'smooth'
                });
            }
        });
    });

    // === CTAボタン表示制御 ===
    var $cta = $('.open-chat-button');
    var $scrollContainer = $('.l-container__inner');
    var $target = $('#cta-act');
    $scrollContainer.on('scroll', function () {
        var containerScrollTop = $scrollContainer.scrollTop();
        var containerHeight = $scrollContainer.innerHeight();
        var scrollHeight = $scrollContainer[0].scrollHeight;
        var targetOffsetTop = $target.position().top;
        var isAtBottom = (containerScrollTop + containerHeight) >= scrollHeight;
        if (targetOffsetTop < 0 && !isAtBottom) {
            $cta.addClass('modcta--visible');
        } else {
            $cta.removeClass('modcta--visible');
        }
    });
});